angular.module('agreements')
    .component('agreementAccessGroupList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/agreements/access-group/list.html',
        controller: function ($scope, $state, AgreementAccessGroupService, AgreementAccessGroupConst) {
            this.reset = () => this.filters = {}
            this.AgreementAccessGroupService = AgreementAccessGroupService
            $scope.$on(AgreementAccessGroupConst.eventUpdate, () => $state.reload())
        }
    })
